import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { IoChevronDownOutline } from 'react-icons/io5';
import styles from './FAQSection.module.scss';

const API_URL = 'https://huongtramcomoc.vn/api/endpoints/get_faqs.php';

const FAQSection = ({ title = "Câu Hỏi Thường Gặp" }) => {
  const [faqs, setFaqs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  // 1. Fetch dữ liệu khi component được gắn vào trang
  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const res = await axios.get(API_URL);
        if (Array.isArray(res.data)) {
          setFaqs(res.data);
        }
      } catch (error) {
        console.error("Lỗi tải FAQ:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFAQs();
  }, []);

  // 2. Xử lý đóng mở Accordion
  const toggleFAQ = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null); // Đóng nếu đang mở
    } else {
      setActiveIndex(index); // Mở câu mới
    }
  };

  // Nếu đang load hoặc không có dữ liệu -> Không hiển thị gì (để giao diện sạch)
  if (!loading && faqs.length === 0) return null;

  return (
    <section className={styles.faqSection}>
      <div className={styles.container}>
        
        {/* Header */}
        <div className={styles.header}>
          <h2>{title}</h2>
          <div className={styles.divider}></div>
        </div>

        {/* Danh sách câu hỏi */}
        <div className={styles.faqList}>
          {loading ? (
            <p style={{textAlign:'center', color:'#999'}}>Đang tải câu hỏi...</p>
          ) : (
            faqs.map((faq, index) => (
              <div 
                key={faq.id} 
                className={`${styles.faqItem} ${activeIndex === index ? styles.active : ''}`}
              >
                <button 
                  className={styles.questionBtn} 
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={activeIndex === index}
                >
                  <span>{faq.question}</span>
                  <IoChevronDownOutline className={styles.icon} />
                </button>
                
                <div className={styles.answerWrapper}>
                  {faq.answer}
                </div>
              </div>
            ))
          )}
        </div>

      </div>
    </section>
  );
};

export default FAQSection;